// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"44fb51fb","453":"fd50e23f","672":"3e9653b0","673":"868e96c9","935":"d4d5ebd1"}[chunkId] + ".chunk.css";
};